"use client";
import React, { useEffect, useRef } from "react";

type AdType = "feed" | "clip";

const AD_CONFIG: Record<AdType, { [key: string]: string }> = {
  feed: {
    "data-ad-slot": "8199077656",
    "data-ad-layout-key": "-6t+ed+2i-1n-4w",
    "data-ad-format": "fluid",
  },
  clip: {
    "data-ad-slot": "2834932654",
    "data-ad-format": "auto",
    "data-full-width-responsive": "true",
  },
};

const AdComponent = ({ adType, id }: { adType: AdType; id: string }) => {
  const adRef = useRef<HTMLDivElement>(null);

  // Fallback to 'feed' if adType is invalid or undefined
  const validAdType = adType && AD_CONFIG[adType] ? adType : "feed";

  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push(
        {}
      );
    } catch (e) {
      console.log("Error loading ad:", e);
    }
  }, []);

  return (
    <div
      className={
        adType === "clip"
          ? "w-full h-full flex items-center justify-center bg-black"
          : "bg-black dark:bg-gray-950 rounded-xl p-3 mb-3 sm:p-4 shadow-lg border dark:border-gray-800"
      }
    >
      <div
        className={
          adType === "clip"
            ? "min-h-[5px] w-full h-full flex items-center justify-center"
            : "min-h-[5px]"
        }
      >
        <ins
          key={`ad-slot-${id}`}
          className="adsbygoogle"
          style={{ display: "block", width: "100%" }}
          data-ad-client="ca-pub-9568000532833270"
          {...AD_CONFIG[validAdType]}
        ></ins>
      </div>
    </div>
  );
};

export default AdComponent;
